import React, { useContext, useEffect, useState, useRef } from 'react'
import * as Showdown from 'showdown'
import axios from 'axios'
import moment from 'moment'
import { get, map, isEmpty, uniqueId, keys } from 'lodash'
import Pagination from 'react-js-pagination'
import {
  AnnotationContext,
  BookInfo,
  MenuContext,
  UserInfo,
  SelectionContext
} from '../../contexts/menuContext'
import AnnotationItem from './annotation-item'
import EditAnnotation from './annotation-edit'

const Annotation = () => {
  const [, , page] = useContext(BookInfo)
  const [annotationObj] = useContext(AnnotationContext)
  const [responseData, setResponseData] = useState({})
  const [, changeMenuStatus, , changeRightSidebar, userClosedMenu] = useContext(MenuContext)
  const [filterMenu, setFilterMenu] = useState(false)
  const [user] = useContext(UserInfo)
  const groups = get(user, 'groups')
  const [filters, setFilters] = useState('none')
  const [pager, setPager] = useState(1)
  const [total, setTotal] = useState(0)
  const pagerLimit = 10
  const [reload, setReload] = useState(false)
  const [, setSelection, ] = useContext(SelectionContext)
  useEffect(() => {
    setPager(1)
  }, [page])
  const converter = new Showdown.Converter({
    tables: true,
    simplifiedAutoLink: true,
    strikethrough: true,
    tasklists: true
  });

  const editorRef = useRef(null);

  useEffect(() => {
    let filtering = ''
    if (!isEmpty(filters) && filters !== 'none') {
      if (['public', 'private'].includes(filters)) {
        switch (filters) {
          case 'private':
            filtering = '?private=1'
            break
          case 'public':
            filtering = '?public=1'
            break
          default:
            filtering = '?public=1'
        }
      } else {
        filtering = `?group=${filters}`
      }
    }
    if (isEmpty(filtering)) {
      filtering += `?offset=${(pager - 1) * pagerLimit}&limit=${pagerLimit}`
    } else {
      filtering += `&offset=${(pager - 1) * pagerLimit}&limit=${pagerLimit}`
    }

    axios.get(`/bookreader/toolbox/annotations/${page}${filtering}`).then((response) => {
      setResponseData(get(response, 'data.data'))
      setTotal(get(response, 'data.total'))
      highlightAnnotations(get(response, 'data.data'));
      scrollToEditor();
    })

    scrollToEditor();
  }, [page, filters, pager, reload])

  const changeFilter = (e) => {
    setFilters(e.target.value)
  }

  const scrollToEditor = () => {
    if (editorRef.current) {
      editorRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }

  const highlightAnnotations = (annotationsObj) => {
    for (const annotationId in annotationsObj) {
      let annotation = annotationsObj[annotationId]
      let subsectionId = annotation.subsectionId
      if (page === subsectionId) {
        const quote = JSON.parse(get(annotation, 'text')) || {}
        if (quote.selection && quote.selection.start !== undefined && quote.selection.end !== undefined) {
          setSelection( {selection: {start: quote.selection.start, end: quote.selection.end}, page: page, text: quote.text })
        }
      }
    }
  }

  return (
    <div className="annotation-wrapper">
      <div className="annotation-header">
        <div
          className="annotation-close"
          onClick={() => {
            changeRightSidebar(false)
            changeMenuStatus(!userClosedMenu)
          }}
        ><svg xmlns="http://www.w3.org/2000/svg" id="Outlined" viewBox="0 0 32 32" fill="currentColor">
          <title/>
          <g id="Fill">
            <polygon points="28.71 4.71 27.29 3.29 16 14.59 4.71 3.29 3.29 4.71 14.59 16 3.29 27.29 4.71 28.71 16 17.41 27.29 28.71 28.71 27.29 17.41 16 28.71 4.71"/>
          </g>
        </svg>
        </div>
      </div>
      <div className="annotation-wrapper-inner">
        { isEmpty(responseData) ? <div
          className="annotation-block"
        >You haven't made any annotations yet. You can create annotations from within books.
        </div> : map(responseData, (obj, i) => {
          const json = JSON.parse(obj.text)
          const fromNow = moment(obj.created * 1000).fromNow()
          return (
            <AnnotationItem
              key={i}
              json={json}
              fromNow={fromNow}
              setReload={setReload}
              obj={{ ...obj }}
              converter={converter}
              removable={keys(responseData).length === 1}
            />
          )
        })}
        {total > pagerLimit && <Pagination
          activePage={pager}
          itemsCountPerPage={pagerLimit}
          totalItemsCount={parseInt(total, 10)}
          itemClass="page-item"
          linkClass="page-link"
          pageRangeDisplayed={5}
          onChange={(pageNumber) => { setPager(pageNumber) }}
        />}

        {annotationObj.text && <div className="annotation-form" ref={editorRef}>
          <blockquote className="annotation-block--quote">{annotationObj.text}</blockquote>
          <EditAnnotation
            annotationObj={annotationObj}
            converter={converter}
            setReload={setReload}
          />
        </div>}
      </div>
    </div>
  )
}

export default Annotation
